"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const cookies_1 = require("../utils/cookies");
const PREFERENCES_COOKIE_NAME = 'medelyPreferences';
const buildCookieName = (accountId) => {
    return `${PREFERENCES_COOKIE_NAME}_${accountId}`;
};
const getInitialPreferences = (cookieName) => {
    const cookie = (0, cookies_1.getCookie)(cookieName) ?? (0, cookies_1.getCookie)(PREFERENCES_COOKIE_NAME);
    return cookie ? JSON.parse(cookie) : {};
};
// this hook currently is just persisting some data in a session cookie. it's built in a
// way that we can easily change it to store a preference object in the database if the
// we do more with preferences later
const usePreferences = (accountId = '') => {
    const cookieName = buildCookieName(accountId);
    const [preferences, setPreferences] = (0, react_1.useState)(getInitialPreferences(cookieName));
    const updatePreferences = (newPreferences) => {
        (0, cookies_1.setCookie)({
            cookieName: cookieName,
            value: { ...preferences, ...newPreferences },
        });
        setPreferences((previousPreferences) => {
            return { ...previousPreferences, ...newPreferences };
        });
    };
    return {
        cookieName,
        preferences,
        updatePreferences,
    };
};
exports.default = usePreferences;
